import classNames from "classnames";

/**
 *
 * @param children -> Whatever text needs to be rendered
 * @param size -> 'l' | 'xl' | 's' | 'xs'
 * @param weight -> 'Bold' | 'Light'
 * @param color -> 'Primary' | 'Secondary'
 * @returns
 */
export const Typography = ({
  children,
  size,
  weight,
  extraClasses,
  onClick,
  color = "text-dark-grey",
}) => {
  let classes = classNames(extraClasses, {
    "font-weight-bold": weight === "Bold",
    "font-weight-semi-bold": weight === "Semi-Bold",
    "light-text": weight === "Light",
    big: size === "l",
    bigger: size === "xl",
    small: size === "s",
    "cs-fs-16": size === "m",
    "extra-small": size === "xs",
    "text-primary-new": color === "text-primary-new",
    "text-purple": color === "text-purple",
    "text-white": color === "text-white",
    "dark-grey": color === "text-dark-grey",
  });
  return (    
    <span className={classes} onClick={onClick}>
      {children}
    </span>
  );
};

// TYPOGRAPHY ACCORDING TO UI REVAMP

// SMALL REGULAR TEXT TYPOGRAPHY
export const SmallRegularText = ({ children, classNames, onClick }) => {
  return (
    <Typography
      onClick={onClick}
      extraClasses={classNames}
      size={"s"}
      weight={"Normal"}
    >
      {children}
    </Typography>
  );
};
// SMALL SEMIBOLD TEXT TYPOGRAPHY
export const SmallSemiBoldText = ({ children, classNames, onClick }) => {
  return (
    <Typography
      onClick={onClick}
      extraClasses={classNames}
      size={"s"}
      weight={"Semi-Bold"}
    >
      {children}
    </Typography>
  );
};
// MEDIUM REGULAR TEXT TYPOGRAPHY
export const MediumRegularText = ({ children, classNames, onClick }) => {
  return (
    <Typography
      onClick={onClick}
      extraClasses={classNames}
      size={"m"}
      weight={"Normal"}
    >
      {children}
    </Typography>
  );
};
// MEDIUM SEMIBOLD TEXT TYPOGRAPHY
export const MediumSemiBoldText = ({ children, classNames, onClick }) => {
  return (
    <Typography
      onClick={onClick}
      extraClasses={classNames}
      size={"m"}
      weight={"Semi-Bold"}
    >
      {children}
    </Typography>
  );
};
// BIG REGULAR TEXT TYPOGRAPHY
export const BigRegularText = ({ children, classNames, onClick }) => {
  return (
    <Typography
      onClick={onClick}
      extraClasses={classNames}
      size={"l"}
      weight={"Normal"}
    >
      {children}
    </Typography>
  );
};
// BIG SEMIBOLD TEXT TYPOGRAPHY
export const BigSemiBoldText = ({ children, classNames, onClick }) => {
  return (
    <Typography
      onClick={onClick}
      extraClasses={classNames}
      size={"l"}
      weight={"Semi-Bold"}
    >
      {children}
    </Typography>
  );
};

// NORMAL TEXT TYPOGRAPHY
export const NormalText = ({ children, classNames, onClick }) => {
  return (
    <Typography onClick={onClick} extraClasses={classNames}>
      {children}
    </Typography>
  );
};
// BOLD TEXT TYPOGRAPHY
export const BoldText = ({ children, classNames, size, onClick }) => {
  return (
    <Typography
      onClick={onClick}
      extraClasses={classNames}
      size={size}
      weight={"Bold"}
    >
      {children}
    </Typography>
  );
};
// LIGHT TEXT TYPOGRAPHY
export const LightText = ({ children, classNames, size, onClick }) => {
  return (
    <Typography
      onClick={onClick}
      extraClasses={classNames}
      size={size}
      weight={"Light"}
    >
      {children}
    </Typography>
  );
};
// SMALL NORMAL TEXT TYPOGRAPHY
export const SmallNormalText = ({ children, classNames, onClick }) => {
  return (
    <Typography
      onClick={onClick}
      extraClasses={classNames}
      size={"s"}
      weight={"Normal"}
    >
      {children}
    </Typography>
  );
};
// SMALL SEMIBOLD TEXT TYPOGRAPHY
// export const SmallSemiBoldText = ({children,}) => {
//     return <Typography extraClasses={classNames} size={"s"} weight={'Semi-Bold'}>{children}</Typography>
// }
// SMALL BOLD TEXT TYPOGRAPHY
export const SmallBoldText = ({ children, classNames, onClick }) => {
  return (
    <Typography
      onClick={onClick}
      extraClasses={classNames}
      size={"s"}
      weight={"Bold"}
    >
      {children}
    </Typography>
  );
};
// SMALL LIGHT TEXT TYPOGRAPHY
export const SmallLightText = ({ children, classNames, onClick }) => {
  return (
    <Typography
      onClick={onClick}
      extraClasses={classNames}
      size={"s"}
      weight={"Light"}
    >
      {children}
    </Typography>
  );
};
// EXTRA SMALL NORMAL TEXT TYPOGRAPHY
export const ExtraSmallNormalText = ({ children, classNames, onClick }) => {
  return (
    <Typography
      onClick={onClick}
      extraClasses={classNames}
      size={"xs"}
      weight={"Normal"}
    >
      {children}
    </Typography>
  );
};
// EXTRA SMALL BOLD TEXT TYPOGRAPHY
export const ExtraSmallBoldText = ({ children, classNames, onClick }) => {
  return (
    <Typography
      onClick={onClick}
      extraClasses={classNames}
      size={"xs"}
      weight={"Bold"}
    >
      {children}
    </Typography>
  );
};
// EXTRA SMALL LIGHT TEXT TYPOGRAPHY
export const ExtraSmallLightText = ({ children, classNames, onClick }) => {
  return (
    <Typography
      onClick={onClick}
      extraClasses={classNames}
      size={"xs"}
      weight={"Light"}
    >
      {children}
    </Typography>
  );
};
// BIG NORMAL TEXT TYPOGRAPHY
export const BigNormalText = ({ children, classNames, onClick }) => {
  return (
    <Typography
      onClick={onClick}
      extraClasses={classNames}
      size={"l"}
      weight={"Normal"}
    >
      {children}
    </Typography>
  );
};
// BIG BOLD TEXT TYPOGRAPHY
export const BigBoldText = ({ children, classNames, onClick }) => {
  return (
    <Typography
      onClick={onClick}
      extraClasses={classNames}
      size={"l"}
      weight={"Bold"}
    >
      {children}
    </Typography>
  );
};
// BIG LIGHT TEXT TYPOGRAPHY
export const BigLightText = ({ children, classNames, onClick }) => {
  return (
    <Typography
      onClick={onClick}
      extraClasses={classNames}
      size={"l"}
      weight={"Light"}
    >
      {children}
    </Typography>
  );
};
// BIG NORMAL TEXT TYPOGRAPHY
export const BiggerNormalText = ({ children, classNames, onClick }) => {
  return (
    <Typography
      onClick={onClick}
      extraClasses={classNames}
      size={"xl"}
      weight={"Normal"}
    >
      {children}
    </Typography>
  );
};
// BIGGER BOLD TEXT TYPOGRAPHY
export const BiggerBoldText = ({ children, classNames, onClick }) => {
  return (
    <Typography
      onClick={onClick}
      extraClasses={classNames}
      size={"xl"}
      weight={"Bold"}
    >
      {children}
    </Typography>
  );
};
// BIGGER LIGHT TEXT TYPOGRAPHY
export const BiggerLightText = ({ children, classNames, onClick }) => {
  return (
    <Typography
      onClick={onClick}
      extraClasses={classNames}
      size={"xl"}
      weight={"Light"}
    >
      {children}
    </Typography>
  );
};
// PRIMARY NORMAL TEXT TYPOGRAPHY
export const PrimaryNormalText = ({ children, classNames, onClick }) => {
  return (
    <Typography
      onClick={onClick}
      extraClasses={classNames}
      color={"text-primary-new"}
    >
      {children}
    </Typography>
  );
};
// PRIMARY BOLD TEXT
export const PrimaryBoldText = ({ children, classNames, onClick }) => {
  return (
    <Typography
      onClick={onClick}
      extraClasses={classNames}
      color={"text-primary-new"}
      weight={"Bold"}
    >
      {children}
    </Typography>
  );
};
// PRIMARY LIGHT TEXT
export const PrimaryLightText = ({ children, classNames, onClick }) => {
  return (
    <Typography
      onClick={onClick}
      extraClasses={classNames}
      color={"text-primary-new"}
    >
      {children}
    </Typography>
  );
};
// PRIMARY SMALL NORMAL TEXT
export const PrimarySmallNormalText = ({ children, classNames, onClick }) => {
  return (
    <Typography
      onClick={onClick}
      extraClasses={classNames}
      size={"s"}
      color={"text-primary-new"}
    >
      {children}
    </Typography>
  );
};
// PRIMARY SMALL BOLD TEXT
export const PrimarySmallBoldText = ({ children, classNames, onClick }) => {
  return (
    <Typography
      onClick={onClick}
      extraClasses={classNames}
      weight={"Bold"}
      size={"s"}
      color={"text-primary-new"}
    >
      {children}
    </Typography>
  );
};
// PRIMARY SMALL LIGHT TEXT
export const PrimarySmallLightText = ({ children, classNames, onClick }) => {
  return (
    <Typography
      onClick={onClick}
      extraClasses={classNames}
      size={"s"}
      color={"text-primary-new"}
    >
      {children}
    </Typography>
  );
};
// PRIMARY EXTRA SMALL NORMAL TEXT
export const PrimaryExtraSmallNormalText = ({
  children,
  classNames,
  onClick,
}) => {
  return (
    <Typography
      onClick={onClick}
      extraClasses={classNames}
      size={"xs"}
      color={"text-primary-new"}
    >
      {children}
    </Typography>
  );
};
// PRIMARY EXTRA SMALL BOLD TEXT
export const PrimaryExtraSmallBoldText = ({
  children,
  classNames,
  onClick,
}) => {
  return (
    <Typography
      onClick={onClick}
      extraClasses={classNames}
      size={"xs"}
      color={"text-primary-new"}
    >
      {children}
    </Typography>
  );
};
// PRIMARY EXTRA SMALL LIGHT TEXT
export const PrimaryExtraSmallLightText = ({
  children,
  classNames,
  onClick,
}) => {
  return (
    <Typography
      onClick={onClick}
      extraClasses={classNames}
      size={"xs"}
      color={"text-primary-new"}
    >
      {children}
    </Typography>
  );
};
// PRIMARY BIG NORMAL TEXT
export const PrimaryBigNormalText = ({ children, classNames, onClick }) => {
  return (
    <Typography
      onClick={onClick}
      extraClasses={classNames}
      size={"l"}
      weight={"Normal"}
      color={"text-primary-new"}
    >
      {children}
    </Typography>
  );
};
// PRIMARY BIG BOLD TEXT
export const PrimaryBigBoldText = ({ children, classNames, onClick }) => {
  return (
    <Typography
      onClick={onClick}
      extraClasses={classNames}
      size={"l"}
      weight={"Bold"}
      color={"text-primary-new"}
    >
      {children}
    </Typography>
  );
};
// PRIMARY BIG LIGHT TEXT
export const PrimaryBigLightText = ({ children, classNames, onClick }) => {
  return (
    <Typography
      onClick={onClick}
      extraClasses={classNames}
      size={"l"}
      weight={"Light"}
      color={"text-primary-new"}
    >
      {children}
    </Typography>
  );
};
// PRIMARY BIGGER NORMAL TEXT
export const PrimaryBiggerNormalText = ({ children, classNames, onClick }) => {
  return (
    <Typography
      onClick={onClick}
      extraClasses={classNames}
      size={"xl"}
      weight={"Normal"}
      color={"text-primary-new"}
    >
      {children}
    </Typography>
  );
};
// PRIMARY BIGGER BOLD TEXT
export const PrimaryBiggerBoldText = ({ children, classNames, onClick }) => {
  return (
    <Typography
      onClick={onClick}
      extraClasses={classNames}
      size={"xl"}
      weight={"Bold"}
      color={"text-primary-new"}
    >
      {children}
    </Typography>
  );
};
// PRIMARY BIGGER LIGHT TEXT
export const PrimaryBiggerLightText = ({ children, classNames, onClick }) => {
  return (
    <Typography
      onClick={onClick}
      extraClasses={classNames}
      size={"xl"}
      weight={"Light"}
      color={"text-primary-new"}
    >
      {children}
    </Typography>
  );
};
// SECONDARY NORMAL TEXT
export const SecondaryNormalText = ({ children, classNames, onClick }) => {
  return (
    <Typography
      onClick={onClick}
      extraClasses={classNames}
      color={"text-purple"}
    >
      {children}
    </Typography>
  );
};
// SECONDARY BOLD TEXT
export const SecondaryBoldText = ({ children, classNames, onClick }) => {
  return (
    <Typography
      onClick={onClick}
      extraClasses={classNames}
      weight={"Bold"}
      color={"text-purple"}
    >
      {children}
    </Typography>
  );
};
// SECONDARY LIGHT TEXT
export const SecondaryLightText = ({ children, classNames, onClick }) => {
  return (
    <Typography
      onClick={onClick}
      extraClasses={classNames}
      color={"text-purple"}
    >
      {children}
    </Typography>
  );
};
// SECONDARY SMALL NORMAL TEXT
export const SecondarySmallNormalText = ({ children, classNames, onClick }) => {
  return (
    <Typography
      onClick={onClick}
      extraClasses={classNames}
      size={"s"}
      color={"text-purple"}
    >
      {children}
    </Typography>
  );
};
// SECONDARY SMALL BOLD TEXT
export const SecondarySmallBoldText = ({ children, classNames, onClick }) => {
  return (
    <Typography
      onClick={onClick}
      extraClasses={classNames}
      size={"s"}
      weight={"Bold"}
      color={"text-purple"}
    >
      {children}
    </Typography>
  );
};
// SECONDARY SMALL LIGHT TEXT
export const SecondarySmallLightText = ({ children, classNames, onClick }) => {
  return (
    <Typography
      onClick={onClick}
      extraClasses={classNames}
      size={"s"}
      color={"text-purple"}
    >
      {children}
    </Typography>
  );
};
// SECONDARY EXTRA SMALL NORMAL TEXT
export const SecondaryExtraSmallNormalText = ({
  children,
  classNames,
  onClick,
}) => {
  return (
    <Typography
      onClick={onClick}
      extraClasses={classNames}
      size={"xs"}
      color={"text-purple"}
    >
      {children}
    </Typography>
  );
};
// SECONDARY EXTRA SMALL BOLD TEXT
export const SecondaryExtraSmallBoldText = ({
  children,
  classNames,
  onClick,
}) => {
  return (
    <Typography
      onClick={onClick}
      extraClasses={classNames}
      size={"xs"}
      color={"text-purple"}
      weight={"Bold"}
    >
      {children}
    </Typography>
  );
};
// SECONDARY EXTRA SMALL LIGHT TEXT
export const SecondaryExtraSmallLightText = ({
  children,
  classNames,
  onClick,
}) => {
  return (
    <Typography
      onClick={onClick}
      extraClasses={classNames}
      size={"xs"}
      color={"text-purple"}
    >
      {children}
    </Typography>
  );
};
// SECONDARY BIG NORMAL TEXT
export const SecondaryBigNormalText = ({ children, classNames, onClick }) => {
  return (
    <Typography
      onClick={onClick}
      extraClasses={classNames}
      size={"l"}
      weight={"Normal"}
      color={"text-purple"}
    >
      {children}
    </Typography>
  );
};
// SECONDARY BIG BOLD TEXT
export const SecondaryBigBoldText = ({ children, classNames, onClick }) => {
  return (
    <Typography
      onClick={onClick}
      extraClasses={classNames}
      size={"l"}
      weight={"Bold"}
      color={"text-purple"}
    >
      {children}
    </Typography>
  );
};
// SECONDARY BIG LIGHT TEXT
export const SecondaryBigLightText = ({ children, classNames, onClick }) => {
  return (
    <Typography
      onClick={onClick}
      extraClasses={classNames}
      size={"l"}
      weight={"Light"}
      color={"text-purple"}
    >
      {children}
    </Typography>
  );
};
// SECONDARY BIGGER NORMAL TEXT
export const SecondaryBiggerNormalText = ({
  children,
  classNames,
  onClick,
}) => {
  return (
    <Typography
      onClick={onClick}
      extraClasses={classNames}
      size={"xl"}
      weight={"Normal"}
      color={"text-purple"}
    >
      {children}
    </Typography>
  );
};
// SECONDARY BIGGER BOLD TEXT
export const SecondaryBiggerBoldText = ({ children, classNames, onClick }) => {
  return (
    <Typography
      onClick={onClick}
      extraClasses={classNames}
      size={"xl"}
      weight={"Bold"}
      color={"text-purple"}
    >
      {children}
    </Typography>
  );
};
// SECONDARY BIGGER LIGHT TEXT
export const SecondaryBiggerLightText = ({ children, classNames, onClick }) => {
  return (
    <Typography
      onClick={onClick}
      extraClasses={classNames}
      size={"xl"}
      weight={"Light"}
      color={"text-purple"}
    >
      {children}
    </Typography>
  );
};

// PRIMARY NORMAL TEXT TYPOGRAPHY
export const WhiteNormalText = ({ children, classNames, onClick }) => {
  return (
    <Typography
      onClick={onClick}
      extraClasses={classNames}
      color={"text-white"}
    >
      {children}
    </Typography>
  );
};
// PRIMARY BOLD TEXT
export const WhiteBoldText = ({ children, classNames, onClick }) => {
  return (
    <Typography
      onClick={onClick}
      extraClasses={classNames}
      weight={"Bold"}
      color={"text-white"}
    >
      {children}
    </Typography>
  );
};
